import { useQuery } from "@tanstack/react-query";
import { activityService } from "../../services/activity";
import { Clock } from "lucide-react";

const ActivityFeed = () => {
  const { data: logs } = useQuery({
    queryKey: ["activities"],
    queryFn: activityService.getActivities,
  });

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
      <h3 className="text-base font-semibold text-gray-900 mb-4">Recent Activity</h3>
      {logs?.length > 0 ? (
        <div className="space-y-4">
          {logs.slice(0, 8).map((log) => (
            <div key={log._id} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs font-bold text-blue-600">{log.user?.name?.[0]?.toUpperCase() || "?"}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-gray-700">
                  <span className="font-medium text-gray-900">{log.user?.name}</span>{" "}
                  {log.action}
                </p>
                <div className="flex items-center gap-1 mt-0.5">
                  <Clock className="w-3 h-3 text-gray-400" />
                  <p className="text-xs text-gray-400">{new Date(log.createdAt).toLocaleString()}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-400 text-sm text-center py-6">No recent activity</p>
      )}
    </div>
  );
};

export default ActivityFeed;
